import React, { useCallback } from "react";
import { Icon, Tooltip } from "@treelab/panda";

import { formatMessage } from "../../lib/intl";

import { ChartType } from "../../types/global-type";

import { barChartSvg, lineChartSvg, stackBarSvg, pieChartSvg, ringPieSvg } from "../../constants/svg";

import { Container, Option } from "./styled";

interface IProps {
  id: string;
  value: ChartType;
  onChange: (value: { [key in string]: ChartType }) => void;
}

const optionList = [
  {
    value: ChartType.BASIC_BAR,
    icon: barChartSvg,
    labelId: "form.option.chart.select.bar",
  },
  {
    value: ChartType.STACKED_COLUMN_BAR,
    icon: stackBarSvg,
    labelId: "form.option.chart.select.bar.stack",
  },
  {
    value: ChartType.BASIC_LINE,
    icon: lineChartSvg,
    labelId: "form.option.chart.select.line",
  },
  {
    value: ChartType.BASIC_PIE,
    icon: pieChartSvg,
    labelId: "form.option.chart.select.pie",
  },
  {
    value: ChartType.PIE_RING,
    icon: ringPieSvg,
    labelId: "form.option.chart.select.pie.ring",
  },
];

const ChartSelect: React.FC<IProps> = ({ value, onChange, id }) => {
  const handleChange = useCallback(
    (data: ChartType) => {
      onChange({ [id]: data });
    },
    [onChange, id]
  );
  return (
    <>
      <Container>
        {optionList.map((item) => (
          <OptionComponent key={item.value} value={item.value} isSelect={item.value === value} onChange={handleChange}>
            <Tooltip
              usePortal={true}
              delay={0}
              offset={[0, 14]}
              placement="bottom"
              contentTitle={formatMessage({ id: item.labelId })}
            >
              <Icon icon={item.icon} size={{ width: 24, height: 24 }} />
            </Tooltip>
          </OptionComponent>
        ))}
      </Container>
    </>
  );
};

const OptionComponent: React.FC<{ onChange: (value: ChartType) => void; value: ChartType; isSelect: boolean }> = ({
  onChange,
  value,
  children,
  isSelect,
}) => {
  const handleChange = useCallback(() => {
    onChange(value);
  }, [onChange, value]);
  return (
    <Option isSelect={isSelect} key={value} onClick={handleChange}>
      {children}
    </Option>
  );
};

export default ChartSelect;
